import { Component, EventEmitter, Output } from '@angular/core';

import { MapsService } from '../../../../../core/service/google/maps/maps.service';

@Component({
  selector: 'modal-view-current-location-button',
  standalone: true,
  imports: [],
  template: `
    <button
      (click)="getCurrentLocation()"
      class="px-3 sm:px-4 py-2 bg-green-500 text-white rounded-full hover:bg-green-600 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-opacity-50 flex items-center space-x-2 transform hover:scale-105 w-full justify-center text-sm sm:text-base shadow-sm"
      [disabled]="isLoading"
      >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="1.5"
        >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
          <span>{{ isLoading ? 'Obteniendo ubicación...' : 'Usar mi ubicación actual' }}</span>
          @if (isLoading) {
            <div class="ml-2 animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          }
        </button>
        @if (errorMessage) {
          <div class="mt-2 text-sm text-red-500 text-center">
            {{ errorMessage }}
          </div>
        }
    `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class CurrentLocationButtonComponent {
  @Output() locationSelected = new EventEmitter<{
    location: { lat: number, lng: number },
    address: string
  }>();

  isLoading = false;
  errorMessage = '';

  constructor(private mapsService: MapsService) {}

  getCurrentLocation(): void {
    this.isLoading = true;
    this.errorMessage = '';

    if (!navigator.geolocation) {
      this.errorMessage = 'Tu navegador no soporta geolocalización';
      this.isLoading = false;
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const location = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        // Obtener la dirección a partir de las coordenadas
        this.mapsService.getAddressFromCoordinates(location).subscribe(result => {
          this.isLoading = false;

          if (result) {
            this.locationSelected.emit({
              location: result.location,
              address: result.address
            });
          } else {
            this.errorMessage = 'No se pudo obtener la dirección de tu ubicación';
          }
        });
      },
      (error) => {
        this.isLoading = false;
        switch (error.code) {
          case error.PERMISSION_DENIED:
            this.errorMessage = 'Permiso de ubicación denegado';
            break;
          case error.POSITION_UNAVAILABLE:
            this.errorMessage = 'Información de ubicación no disponible';
            break;
          case error.TIMEOUT:
            this.errorMessage = 'Tiempo de espera agotado para obtener ubicación';
            break;
          default:
            this.errorMessage = 'Error desconocido al obtener ubicación';
            break;
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  }
}